import { cn } from '../../lib/utils';

export function TypingIndicator({ typingUsers, isDark }) {
  if (typingUsers.length === 0) return null;
  
  return (
    <div className={cn(
      'px-4 py-2 border-t',
      isDark ? 'border-white/5 bg-zinc-900/30' : 'border-gray-100 bg-gray-50'
    )}>
      <div className="flex items-center gap-2">
        <div className="flex gap-1">
          <span className="w-2 h-2 bg-red-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-2 h-2 bg-red-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2 h-2 bg-red-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </div>
        <span className={cn(
          'text-sm italic',
          isDark ? 'text-zinc-400' : 'text-gray-500'
        )}>
          {typingUsers.length === 1 
            ? `${typingUsers[0]} est en train d'écrire...`
            : `${typingUsers.join(', ')} sont en train d'écrire...`
          }
        </span>
      </div>
    </div>
  );
}
